<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>检品统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="5" class="display-row">
            <div class="query-title" style="float: right">员工:</div>
            <div class="flex1" style="float: right">
              <el-select
                v-model="queryInfo.userId"
                placeholder="请选择"
                size="small"
                clearable>
                <el-option
                  v-for="item in userList"
                  :key="item.userId"
                  :label="item.userName + '(' + item.realName + ')'"
                  :value="item.userId">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="19" class="display-row">
            <div
              style="
                text-align: right;
                width: 100%;
                padding-right: 10px;
                float: right;">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList()">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
        :header-cell-style="tableStyle.headerStyle"
        :cell-style="tableStyle.cellStyle"
        :data="checkCountList"
        border
        height="500">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="checkUserId" label="员工ID"></el-table-column>
          <el-table-column prop="checkUserName" label="员工姓名"></el-table-column>
          <el-table-column prop="monthCount" align="center" label="月检品数量"></el-table-column>
          <el-table-column prop="quarterCount" align="center" label="季度检品数量"></el-table-column>
          <el-table-column prop="yearCount" align="center" label="年检品数量"></el-table-column>
        </el-table>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
export default {
  components: { tableCon },
  data() {
    return {
      queryInfo: {
        userId: ""
      },
      userList: [],
      checkCountList: [],
    };
  },
  methods: {
    searchList() {
      //查询
      console.log(this.queryInfo);
      this.getUserList();
      this.getCheckCountList();
    },
    async getCheckCountList() {
      //获取信息列表
      this.$http.get('/order/checkCount', {
        params: this.queryInfo,
      }).then(res => {
        let data = res.data
        this.checkCountList = data.data
      })
    },
    async getUserList() {
      //获取用户列表
      const { data: res } = await this.$http.get("emp/empSystemManage/listAll");
      this.userList = res.data;
    },
    queryInfoClear() {
      //清空
      this.queryInfo = {
        userId: ""
      };
    },
  },
  created() {
    this.getUserList();
    this.getCheckCountList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
